import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { TemporaryStorageState } from '#/hooks/useTemporaryStorage';
import { useTemporaryStorageHandler } from '#/hooks/useTemporaryStorageHandler';
import type { Action } from '#/utils/temporaryStorage';

type TemporaryStorageContextType = {
  temporaryStorage: TemporaryStorageState | null;
  saveTemporaryStorage: (actions: Action[]) => Promise<string>;
  loaded: boolean;
};

export const TmpStorageContext = createContext<TemporaryStorageContextType>({
  temporaryStorage: null,
  saveTemporaryStorage: () => Promise.resolve(''),
  loaded: false,
});

export function TmpStorageContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { temporaryStorage, saveTemporaryStorage, loaded } =
    useTemporaryStorageHandler();

  return (
    <TmpStorageContext.Provider
      value={{ temporaryStorage, saveTemporaryStorage, loaded }}
    >
      {children}
    </TmpStorageContext.Provider>
  );
}

export const useTmpStorageContext = () => useContext(TmpStorageContext);
